module.exports = __webpack_public_path__ + "static/media/C6v6.82344e3e.mp3";